var _path, _path2, _mask, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerfilHomem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 164,
    viewBox: "0 0 162 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 160.5C124.907 160.5 160.5 124.907 160.5 81C160.5 37.0934 124.907 1.5 81 1.5C37.0934 1.5 1.5 37.0934 1.5 81C1.5 124.907 37.0934 160.5 81 160.5Z",
    fill: "#CCEFFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 3C124.078 3 159 37.922 159 81C159 124.078 124.078 159 81 159C37.922 159 3 124.078 3 81C3 37.922 37.922 3 81 3ZM81 0C36.336 0 0 36.336 0 81C0 125.664 36.336 162 81 162C125.664 162 162 125.664 162 81C162 36.336 125.664 0 81 0Z",
    fill: "#1B3858"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 156,
    height: 156
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.5 81C158.5 123.802 123.802 158.5 81 158.5C38.1979 158.5 3.5 123.802 3.5 81C3.5 38.1979 38.1979 3.5 81 3.5C123.802 3.5 158.5 38.1979 158.5 81Z",
    fill: "#D4EEFE",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.122 162H17.878V99.5C17.878 88.515 26.783 79.61 37.768 79.61H124.232C135.217 79.61 144.122 88.515 144.122 99.5V162Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.122 163.5H17.878C17.05 163.5 16.378 162.828 16.378 162V99.5C16.378 87.706 25.974 78.11 37.768 78.11H124.233C136.027 78.11 145.623 87.706 145.623 99.5V162C145.622 162.828 144.95 163.5 144.122 163.5ZM19.378 160.5H142.622V99.5C142.622 89.36 134.372 81.11 124.232 81.11H37.768C27.628 81.11 19.378 89.36 19.378 99.5V160.5Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 61.618H72V79.61H90V61.618Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5 81.11H70.5V60.118H91.5V81.11ZM73.5 78.11H88.5V63.118H73.5V78.11Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.154 122.689H17.878V162H35.154V122.689Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.653 163.5H16.378V121.189H36.653V163.5ZM19.378 160.5H33.653V124.189H19.378V160.5Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.154 110.694H17.878V122.689H35.154V110.694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.153 124.189H17.878C17.05 124.189 16.378 123.517 16.378 122.689V110.694C16.378 109.866 17.05 109.194 17.878 109.194H35.153C35.981 109.194 36.653 109.866 36.653 110.694V122.689C36.653 123.518 35.981 124.189 35.153 124.189ZM19.378 121.189H33.653V112.194H19.378V121.189Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.123 122.689H126.847V162H144.123V122.689Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.622 163.5H125.347V121.189H145.622V163.5ZM128.347 160.5H142.622V124.189H128.347V160.5Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.123 110.694H126.847V122.689H144.123V110.694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.122 124.189H126.847C126.019 124.189 125.347 123.517 125.347 122.689V110.694C125.347 109.866 126.019 109.194 126.847 109.194H144.122C144.95 109.194 145.622 109.866 145.622 110.694V122.689C145.622 123.518 144.95 124.189 144.122 124.189ZM128.347 121.189H142.622V112.194H128.347V121.189Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 79.61C100 90.103 91.493 98.61 81 98.61C70.507 98.61 62 90.103 62 79.61H100Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 100.11C69.696 100.11 60.5 90.914 60.5 79.61V78.11H101.5V79.61C101.5 90.914 92.304 100.11 81 100.11ZM63.563 81.11C64.327 90.06 71.855 97.11 81 97.11C90.145 97.11 97.673 90.06 98.437 81.11H63.563Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 45.718V39.454V38.232V30.602V29.882V26.842C63.5 23.719 65.623 20.825 68.702 20.3C71.916 19.751 74.775 21.637 75.758 24.41H93.16C96.109 24.41 98.5 26.801 98.5 29.75V38.232V39.454V45.718C98.5 46.345 97.992 46.853 97.365 46.853H97.352C96.725 46.853 96.217 46.345 96.217 45.718V40.976C96.217 40.136 95.536 39.454 94.695 39.454H67.304C66.464 39.454 65.519 40.135 65.519 40.976V45.718",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.103 31.376H63.5V22.207C63.5 19.331 65.831 17 68.707 17H88.346V17.133C88.346 25 81.969 31.376 74.103 31.376Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 48.663C61.791 48.663 60 46.872 60 44.663C60 42.454 61.791 40.663 64 40.663",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 50.163C60.968 50.163 58.5 47.695 58.5 44.663C58.5 41.631 60.968 39.163 64 39.163V42.163C62.621 42.163 61.5 43.284 61.5 44.663C61.5 46.042 62.621 47.163 64 47.163V50.163Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.879 48.784C100.155 48.784 102 46.939 102 44.663C102 42.387 100.155 40.542 97.879 40.542",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.879 50.284V47.284C99.324 47.284 100.5 46.108 100.5 44.663C100.5 43.217 99.324 42.041 97.879 42.041V39.041C100.979 39.041 103.5 41.563 103.5 44.663C103.5 47.763 100.979 50.284 97.879 50.284Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.07 72.0001H89.93C93.724 72.0001 96.799 68.9251 96.799 65.1311V39.7541C96.799 37.4781 94.954 35.6331 92.678 35.6331H69.323C67.047 35.6331 65.202 37.4781 65.202 39.7541V65.1311C65.201 68.9251 68.277 72.0001 72.07 72.0001Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.93 73.5001H72.07C67.455 73.5001 63.701 69.7461 63.701 65.1311V39.7541C63.701 36.6541 66.223 34.1331 69.323 34.1331H92.677C95.777 34.1331 98.299 36.6541 98.299 39.7541V65.1311C98.299 69.7461 94.545 73.5001 89.93 73.5001ZM69.323 37.1331C67.877 37.1331 66.701 38.3091 66.701 39.7541V65.1311C66.701 68.0921 69.109 70.5001 72.07 70.5001H89.93C92.891 70.5001 95.299 68.0921 95.299 65.1311V39.7541C95.299 38.3091 94.123 37.1331 92.677 37.1331H69.323Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.757 54.814C72.757 59.366 76.447 63.057 81 63.057C85.553 63.057 89.243 59.367 89.243 54.814",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 49C75.447 49 75 48.553 75 48C75 47.448 74.552 47 74 47C73.448 47 73 47.448 73 48C73 48.553 72.553 49 72 49C71.447 49 71 48.553 71 48C71 46.346 72.346 45 74 45C75.654 45 77 46.346 77 48C77 48.553 76.553 49 76 49Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 49C89.447 49 89 48.553 89 48C89 47.448 88.552 47 88 47C87.448 47 87 47.448 87 48C87 48.553 86.553 49 86 49C85.447 49 85 48.553 85 48C85 46.346 86.346 45 88 45C89.654 45 91 46.346 91 48C91 48.553 90.553 49 90 49Z",
    fill: "#1B3858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 81,
    y1: 162,
    x2: 81,
    y2: 79.6103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfilHomem);
export default __webpack_public_path__ + "static/media/perfil-homem.78282affc92bc4b6dd11dc9b5e7c247a.svg";
export { ForwardRef as ReactComponent };